var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Location",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 8.5 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M4.252,10a.679.679,0,0,1-.367-.124,10.756,10.756,0,0,1-2.77-2.57A5.192,5.192,0,0,1,0,4.159,4.084,4.084,0,0,1,1.252,1.217,4.265,4.265,0,0,1,4.247,0,4.212,4.212,0,0,1,8.5,4.159,5.2,5.2,0,0,1,7.385,7.306a10.96,10.96,0,0,1-2.771,2.57A.66.66,0,0,1,4.252,10ZM4.247,2.889a1.4,1.4,0,0,0-1.4,1.4,1.356,1.356,0,0,0,.411.977,1.412,1.412,0,0,0,2.4-.977,1.412,1.412,0,0,0-1.406-1.4Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M4.252,10a.679.679,0,0,1-.367-.124,10.756,10.756,0,0,1-2.77-2.57A5.192,5.192,0,0,1,0,4.159,4.084,4.084,0,0,1,1.252,1.217,4.265,4.265,0,0,1,4.247,0,4.212,4.212,0,0,1,8.5,4.159,5.2,5.2,0,0,1,7.385,7.306a10.96,10.96,0,0,1-2.771,2.57A.66.66,0,0,1,4.252,10ZM4.247,2.889a1.4,1.4,0,0,0-1.4,1.4,1.356,1.356,0,0,0,.411.977,1.412,1.412,0,0,0,2.4-.977,1.412,1.412,0,0,0-1.406-1.4Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color-2",
    "data-name": "Color",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color-3",
    "data-name": "Color",
    transform: "translate(-1.75 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "color_green",
    "data-name": "color/green",
    width: 24,
    height: 24,
    rx: 4,
    fill: "#05ce78"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGreen);
export default __webpack_public_path__ + "static/media/LocationGreen.ab42d20f390607dc991252c05d5e6a7c.svg";
export { ForwardRef as ReactComponent };